import { catchError, switchMap, map } from 'rxjs/operators';
import {
  Injectable,
  Output,
  EventEmitter,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { environment } from '../../../environments/environment';
//import { tokenNotExpired } from '../../../../node_modules/angular2-jwt/angular2-jwt';
import Auth0Lock from 'auth0-lock';
import { ILogin } from '../models/login';
import {
  HttpClient,
  HttpResponse,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';
import { IUser } from '../models/user';
import { SharedService } from '../../shared/providers/shared.service';
import { UserManagerService } from '../../shared/providers/user-manager.service';
import { ToastService } from '../../shared/providers/toast.service';
import { AuthenticationService } from '../../shared/auth/authentication.service';
import { CommonService } from '../../shared/providers/common.service';
import { LoaderService } from '../providers/loader.service';
import { PropertyManagementService } from '../../shared/providers/property-management.service';
import { ValidationService } from '../../shared/providers/validation.service';
import { BrowserService } from '../../shared/browser-service.service';
import { IFileUpload, IPropertyFileUpload } from '../models/fileupload';
import { PropertyFile } from '../models/SavePropertyInputModel';
import { Observable, of, Subject } from 'rxjs';
import { FileUploadService } from '../providers/fileupload.service';
import { FooterComponent } from '../footer/footer.component';
import { observable } from 'rxjs';
import { AnalyticsService } from '../providers/analytics.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PermissionService } from '../providers/permission.service';
@Injectable()
export class AuthService {
  readonly BaseUrl = environment.base_url;
  redirectUrl = '';
  isRegistration = false;
  showImageStatus: boolean = false;
  authResponse = {} as IUser;
  IsDetailsPage: string;
  PropertyGuid: string = '';
  PropertyToken: string = '';
  SharedGuid: string = '';
  IsLoginFromResetCalled = false;
  logoutClicked: boolean = false;
  loginModel = {} as ILogin;
  passwordReset: TemplateRef<null>;
  modalRef: BsModalRef;
  unresolvedFlagModal: TemplateRef<null>;
  imagesList!: Observable<IPropertyFileUpload[]>;
  imagesListData!: Observable<IPropertyFileUpload[]>;
  OngoingImageCount: number = 0;
  CompletedImageCount: number = 0;
  FailedImageCount: number = 0;
  totalImageCount: number = 0;
  modalRefunresolvedFlag: BsModalRef;
  modalBuyerQuestionnaire: BsModalRef;
  modalIsEBRA: BsModalRef;
  modalCompletedUploads: BsModalRef;
  pendingBuyerQuestionnaireFlagModal: TemplateRef<null>;
  EBRAModal: TemplateRef<null>;
  uploadedFiles: IPropertyFileUpload[] = [];
  modalImageUploadedList1: string = '';
  modalImageUploadedList: BsModalRef;
  ImageUploadedListModal: TemplateRef<null>;
  logoutTemplate: TemplateRef<null>;
  modalRefLogout: BsModalRef;
  userList: object[];
  lock: any;
  currentUser: any;
  unresolvedFlagCount: number = 0;
  isPendingBuyerQuestions = false;
  IsLogOut = false;
  IsFroWordPress = false;
  propertyDocs: IPropertyFileUpload[] = [];
  private customSubject = new Subject<any>();
  openMenuinHeader = new Subject<string>();
  customObservable: any;
  s3Url =
    'https://be-dev.s3.amazonaws.com/BE/Documents/Property/38063/1031-Report-PrincipalBE-03-18-2024638560469514762304.pdf?AWSAccessKeyId=AKIAQ7EEW53LE54MBDRE&Expires=1721987491&Signature=kjMNp3c83OE14ViWJ2R5oOjeaHY%3D';

  //////--- Auth0 --//

  auth0Options = {
    theme: {
      logo: environment.siteurl + '/assets/img/logos/logo-white.png',
      primaryColor: '#DFA612',
    },
    avatar: null,
    allowForgotPassword: true,
    allowShowPassword: true,
    rememberLastLogin: false,
    auth: {
      redirect: environment.auth0.redirect,
      sso: true,
      redirectUrl: environment.auth0.callbackURL,
      responseType: 'token',
      //audience: `https://${environment.auth0.domain}/userinfo`,
    },
    languageDictionary: {
      signUpTerms:
        "By signing up, you agree to our <a href='" +
        environment.WPsiteurl +
        "terms-and-conditions' target='_blank'>terms of service</a> and <a href='" +
        environment.WPsiteurl +
        "privacy-policy' target='_blank'>privacy policy</a>.",
    },
    autoclose: true,
    ////code omitted for brevity
    //configurationBaseUrl: environment.auth0.configurationBaseUrl,
    //overrides: {
    //    __tenant: environment.auth0.tenant,
    //    __token_issuer: environment.auth0.customdomain
    //},
    ////code omitted for brevity
  };
  //lock = new Auth0Lock(
  //  environment.auth0.clientId,
  //  environment.auth0.domain,
  //  this.auth0Options
  //);
  constructor(
    public router: Router,
    private _http: HttpClient,
    private Shared: SharedService,
    private _fileUploadService: FileUploadService,
    private userManagerService: UserManagerService,
    private authService: AuthenticationService,
    private _toastService: ToastService,
    private _loaderService: LoaderService,
    private _commonService: CommonService,
    private browserService: BrowserService,
    private modalService: BsModalService,
    private _propertyManagement: PropertyManagementService,
    private _validationService: ValidationService,
    private activatedRoute: ActivatedRoute,
    private Analytics: AnalyticsService,
    private permissionService: PermissionService
  ) {
    if (!this.browserService.document) {
      return;
    }
    let url1 = this.PropertyGuid;
    const document = this.browserService.document;
    const scriptElement = document.createElement('script');
    scriptElement.type = 'text/javascript';
    scriptElement.async = true;
    scriptElement.defer = true;
    scriptElement.onload = () => this.onAuth0LockLoaded();
    scriptElement.src = 'https://cdn.auth0.com/js/lock/11.5.2/lock.min.js';
    if (this.authService != null && this.authService != undefined) {
      if (
        this.authService.Admin() ||
        this.authService.SuperAdmin() ||
        this.authService.Principal() ||
        this.authService.Principal1031() ||
        this.authService.Seller()
      ) {
        if (
          localStorage.getItem('PropertyTypesValues') == null ||
          localStorage.getItem('PropertyTypesValues') == undefined ||
          localStorage.getItem('PropertyTypesValues') == ''
        )
          this.GetMarketSnapShotTypeData();
      }
    }
    document.body.appendChild(scriptElement);
    if (
      localStorage.getItem('CurrentActivePage') == null ||
      localStorage.getItem('CurrentActivePage') == ''
    ) {
      if (localStorage.getItem('ListingTab') != null) {
        localStorage.removeItem('ListingTab');
      }
      if (localStorage.getItem('1031Tab') != null) {
        localStorage.removeItem('1031Tab');
      }
      if (localStorage.getItem('PageStatus') != null) {
        localStorage.removeItem('PageStatus');
      }
    }
    if (
      localStorage.getItem('UploadedImageList') != null &&
      localStorage.getItem('UploadedImageList') != ''
    ) {
      localStorage.removeItem('UploadedImageList');
    }

    if (this.customObservable == null || this.customObservable == undefined) {
      this.customObservable = this.customSubject.asObservable();
    }
  }
  login() {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      if (this.router.url.indexOf('viewproperty') > -1) {
        sessionStorage.setItem('viewproperty', '1');
        let currentRedirectUrl1 = this.router.url;
        sessionStorage.setItem('currentRedirectUrl', currentRedirectUrl1);
      }

      if (params['sourcetoken'] != null && params['sourcetoken'] != undefined) {
        this.SharedGuid = params['sourcetoken'];
        let activeTab =
          params['tab'] != null && params['tab'] != undefined
            ? params['tab']
            : 'Diligence';
        let currentRedirectUrl1 =
          '/viewproperty/' + this.SharedGuid + '?tab=' + activeTab;
        sessionStorage.setItem('currentRedirectUrl', currentRedirectUrl1);
      } else if (params['source'] != null && params['source'] != undefined) {
        let currentRedirectUrl1 = this.router.url;
        if (currentRedirectUrl1 != null && currentRedirectUrl1 != '') {
          sessionStorage.setItem('currentRedirectUrl', currentRedirectUrl1);
        }
      } else if (
        params['signEBRA'] != true &&
        params['signEBRA'] != undefined
      ) {
        let currentRedirectUrl1 = '/propertylisting?tab=netleasemarketing/';
        localStorage.setItem('1031Tab', '1');
        if (currentRedirectUrl1 != null && currentRedirectUrl1 != '') {
          sessionStorage.setItem('currentRedirectUrl', currentRedirectUrl1);
        }
      } else if (this.router.url.indexOf('my-profile') > -1) {
        sessionStorage.setItem('currentRedirectUrl', '/my-profile');
      }
    });
    if (
      this.PropertyToken != null &&
      this.PropertyToken != '' &&
      this.PropertyGuid != '' &&
      this.PropertyGuid != null
    ) {
      let currenturl =
        '/viewproperty/' +
        this.PropertyGuid +
        '?token=' +
        this.PropertyToken +
        '&utm_medium=link&utm_source=be_web&utm_campaign=ShareListing&utm_content=link';
      sessionStorage.setItem('currentRedirectUrl', currenturl);
      localStorage.setItem('IsFromCopyLink', currenturl);
    }
    if (this.lock == null || this.lock == undefined) {
      this.checkAuthentication();
      var that = this;
      setTimeout(() => {
        that.lock.show();
        let closeButton = document.querySelector('.auth0-lock-close-button');
        closeButton.addEventListener('click', function handleClick(event) {
          let currentRedirectUrl = sessionStorage.getItem('currentRedirectUrl');
          if (
            currentRedirectUrl != null &&
            currentRedirectUrl != undefined &&
            currentRedirectUrl.indexOf('my-profile') > -1
          ) {
            sessionStorage.removeItem('currentRedirectUrl');
          }
        });
      }, 1000);
    } else {
      this.lock.show();
      let closeButton = document.querySelector('.auth0-lock-close-button');
      closeButton.addEventListener('click', function handleClick(event) {
        let currentRedirectUrl = sessionStorage.getItem('currentRedirectUrl');
        if (
          currentRedirectUrl != null &&
          currentRedirectUrl != undefined &&
          currentRedirectUrl.indexOf('my-profile') > -1
        ) {
          sessionStorage.removeItem('currentRedirectUrl');
          this.router.navigate(['/propertylisting'], {
            queryParams: { request: 'buy' },
          });
        }
      });
    }
  }

  logout() {
    this.WriteLog('logout', ' ');
    this.authService.logout();
    if (this.IsLogOut) {
      this._loaderService.display(true);
      this.IsLogOut = false;
      this.lock.logout({
        returnTo: this._validationService.removeLastCharacterFromString(
          environment.WPsiteurl
        ),
      });
    } else if (!this.IsFroWordPress) {
      $('body').removeClass('open-sidemenu');
      this.router.navigate(['/propertylisting'], {
        queryParams: { request: 'buy' },
      });
    }
  }
  isAuthenticated() {
    var status = true; //tokenNotExpired();
    if (!status) {
      this.logout();
    }
    return status;
  }
  hidePasswordResetPopup() {
    this.modalRef.hide();
    this.login();
  }
  onAuth0LockLoaded() {
    const Auth0Lock = this.browserService.window.Auth0Lock;
    this.lock = new Auth0Lock(
      environment.auth0.clientId,
      environment.auth0.domain,
      this.auth0Options
    );

    //setTimeout(() => {
    try {
      this.lock.on('authenticated', (authResult: any) => {
        var date = new Date().toString();

        localStorage.setItem('isTokenExpired', 'true');
        localStorage.setItem('tokenRefreshTime', date);
        this._loaderService.display(true);
        this.lock.getUserInfo(authResult.accessToken, (error, profile) => {
          if (profile) {
            this.WriteLog('LogIn', profile);
          }
          this._loaderService.display(true);
          this.authService.redirectUser.subscribe((res) => {
            this.authService.redirectUrl = localStorage.getItem('redirectUrl');
          });

          let currentRedirectUrl = sessionStorage.getItem('currentRedirectUrl');
          if (localStorage.getItem('ListingTab') != null) {
            localStorage.removeItem('ListingTab');
          }
          if (localStorage.getItem('1031Tab') != null) {
            localStorage.removeItem('1031Tab');
          }
          if (localStorage.getItem('PageStatus') != null) {
            localStorage.removeItem('PageStatus');
          }
          this.loginModel.UserName = profile['email'];
          this.loginModel.Password = '';
          this.authService.Auth0login(this.loginModel).subscribe((response) => {
            this._loaderService.display(true);
            this.authResponse = response;
            if (this.authResponse.IsAuthenticated) {
              if (this.authResponse.IsAccountVerified) {
                this.authService.verifiedIn.next(true);
                if (
                  this.authService.Admin() ||
                  this.authService.SuperAdmin() ||
                  this.authService.DataEntryStaff()
                ) {
                  this.onLogin(true);
                }
                localStorage.setItem('userId', JSON.stringify(this.authResponse.Id));
                this.userManagerService
                  .GetUserPermissions(this.authResponse.Id)
                  .subscribe((res) => {
                    this._loaderService.display(false);
                    var permissions = res;
                    this.GetUploadedImages();
                    localStorage.setItem(
                      'MenuPermissions',
                      JSON.stringify(permissions)
                    );

                    if (
                      this.authService.Admin() ||
                      this.authService.SuperAdmin() ||
                      this.authService.Principal() ||
                      this.authService.Principal1031() ||
                      this.authService.Seller()
                    ) {
                      this.GetMarketSnapShotTypeData();
                    }
                    if (
                      this.authService.Broker() ||
                      this.authService.ExternalBroker() ||
                      this.authService.Principal() ||
                      this.authService.Principal1031()
                    ) {
                      if (this.authResponse.IsTcAccepted == true) {
                        this.CheckPendingBuyerQuestionnaire(this.authResponse.Id);
                        if (
                          this.authService.Principal() ||
                          this.authService.Principal1031()
                        ) {
                          this.CheckIfUserAccepted1031TradeParticipationAgreement(
                            this.authResponse.Guid
                          );
                        }
                      }
                    }
                    if (currentRedirectUrl == null || currentRedirectUrl == '') {
                      if (
                        this.authService.IsUserRole(
                          this.authService.UserRole.Principal
                        ) ||
                        this.authService.IsUserRole(
                          this.authService.UserRole.Principal1031
                        )
                      ) {
                        currentRedirectUrl = '/principal-dashboard';
                        sessionStorage.setItem(
                          'currentRedirectUrl',
                          '/principal-dashboard'
                        );
                      }
                    }
                    if (
                      this.authResponse.IsTcAccepted == true &&
                      currentRedirectUrl != null &&
                      currentRedirectUrl != ''
                    ) {
                      this.authResponse.RedirectUrl = currentRedirectUrl;
                    }
                    this._toastService.addToast({
                      title: 'Success',
                      msg: 'You are successfully logged in',
                      timeout: 5000,
                      theme: 'bootstrap',
                      position: 'bottom-right',
                      type: 'success',
                    });

                    if (
                      this.authResponse.RedirectUrl != '' &&
                      this.authResponse.RedirectUrl != null
                    ) {
                      // For 1031 access
                      if (
                        currentRedirectUrl != null &&
                        currentRedirectUrl != ''
                      ) {
                        if (this.authResponse.IsTcAccepted == true) {
                          if (currentRedirectUrl.indexOf('my-profile') > -1) {
                            this.router
                              .navigateByUrl('/', { skipLocationChange: true })
                              .then(() => this.router.navigate(['/my-profile']));
                          } else {
                            this.router
                              .navigateByUrl('/', { skipLocationChange: true })
                              .then(() => this.router.navigateByUrl(currentRedirectUrl));
                          }
                          if (
                            sessionStorage.getItem('currentRedirectUrl') != null
                          ) {
                            sessionStorage.removeItem('currentRedirectUrl');
                          }
                        } else {
                          this.router
                            .navigateByUrl('/', { skipLocationChange: true })
                            .then(() => this.router.navigateByUrl(this.authResponse.RedirectUrl));
                        }
                      } else {
                        this.router
                          .navigateByUrl('/', { skipLocationChange: true })
                          .then(() => this.router.navigateByUrl(this.authResponse.RedirectUrl));
                      }
                    } else if (
                      this.authService.redirectUrl &&
                      this.authService.redirectUrl != ''
                    ) {
                      if (
                        this.authService.Principal() ||
                        this.authService.Principal1031()
                      ) {
                        let URL = this.authService.redirectUrl.split('/')[1];
                        if (URL != '') {
                          this._commonService
                            .IsOfferPlaced(URL, this.authResponse.Id)
                            .subscribe((res) => {
                              if (res == false) {
                                if (
                                  currentRedirectUrl != null &&
                                  currentRedirectUrl != ''
                                ) {
                                  if (this.authResponse.IsTcAccepted == true) {
                                    if (
                                      currentRedirectUrl.indexOf('my-profile') >
                                      -1
                                    ) {
                                      this.router
                                        .navigateByUrl('/', {
                                          skipLocationChange: true,
                                        })
                                        .then(() =>
                                          this.router.navigate(['/my-profile'])
                                        );
                                    } else {
                                      this.router
                                        .navigateByUrl('/', { skipLocationChange: true })
                                        .then(() => this.router.navigateByUrl(currentRedirectUrl));
                                    }
                                    if (
                                      sessionStorage.getItem(
                                        'currentRedirectUrl'
                                      ) != null
                                    ) {
                                      sessionStorage.removeItem(
                                        'currentRedirectUrl'
                                      );
                                    }
                                  } else {
                                    this.router
                                      .navigateByUrl('/', { skipLocationChange: true })
                                      .then(() => this.router.navigateByUrl(this.authService.redirectUrl));
                                  }
                                }
                              }
                              // this.clearRedeirectUrl();
                            });
                        }
                      }
                    }
                    else {
                      this.router
                        .navigateByUrl('/', { skipLocationChange: true })
                        .then(() => this.router.navigate(['/propertylisting'], {
                          queryParams: { request: 'buy' },
                        }));
                    }
                    window.scrollTo(0, 0);
                  });
              }
              else {
                this.isRegistration = true;
                this.authResponse.IsAuthenticated = false;
                localStorage.setItem('userGuidForAuthentication', JSON.stringify(this.authResponse.Guid));
                document.getElementById('hdnauthenticateauth0').click();
              }

            } else {
              this.isRegistration = true;
              document.getElementById('hdnsignupauth0').click();
            }
          });
        });
      });
      this.lock.checkSession({}, (err, authResult) => {
        if (!err && authResult) {
          let loggedUserDetails = (JSON.parse(localStorage.getItem('currentUser')));
          let userId = loggedUserDetails != null ? loggedUserDetails.Id : 0;
          if (userId > 0) {
            this.loadRoleBasedPermissions(loggedUserDetails.RoleId)
            this.userManagerService.CheckIfUserDeletedAccount(userId).subscribe(response => {
              let userDeleteStatus = response as boolean;

              if (userDeleteStatus) {
                this.userManagerService.CheckIfUserVerifiedAccount(userId).subscribe(response => {
                  let userStatus = response as boolean;
                  if (userStatus) {
                    this.authService.verifiedIn.next(true);
                  }
                  else {
                    this.authService.verifiedIn.next(false);
                    localStorage.setItem('userGuidForAuthentication', JSON.stringify(loggedUserDetails.Guid));
                    document.getElementById('hdnauthenticateauth0').click();
                  }
                });
              }
              else {
                this.lock.hide();
                this.logout();
              }
            });
          }
        } else {
          let loggedUserDetails = (JSON.parse(localStorage.getItem('currentUser')));
          let userId = loggedUserDetails != null ? loggedUserDetails.Id : 0;
          if (userId > 0) {
            this.loadRoleBasedPermissions(loggedUserDetails.RoleId)
            this.userManagerService.CheckIfUserDeletedAccount(userId).subscribe(response => {
              let userDeleteStatus = response as boolean;

              if (!userDeleteStatus) {
                this.lock.hide();
                this.logout();
              }
            });
          }

        }
      });
      this.lock.on('authorization_error', (error) => {
        var emailId = $('#1-email').val();
        if (error.code == 'invalid_user_password') {
          this.auth0SearchUserByEmailId(emailId).subscribe((response) => {
            response.subscribe((res) => {
              if (
                res[0]['user_metadata'] &&
                res[0]['user_metadata'].ispasswordreset
              ) {
                this.auth0ResetPasswordApi(emailId);
                this.lock.hide();
              }
            });
          });
        }
      });
    } catch (e) {
      console.log(e);
    }
    //}, 1000);
  }

  callComponentMethod(value: any) {
    if (this.customObservable == null || this.customObservable == undefined) {
      this.customObservable = this.customSubject.asObservable();
    }
    this.customSubject.next(value);
  }

  checkAuthentication() {
    const document = this.browserService.document;
    const scriptElement = document.createElement('script');
    scriptElement.type = 'text/javascript';
    scriptElement.async = true;
    scriptElement.defer = true;
    scriptElement.onload = () => this.onAuth0LockLoaded();
    scriptElement.src = 'https://cdn.auth0.com/js/lock/11.5.2/lock.min.js';
    document.body.appendChild(scriptElement);
    setTimeout(() => {
      this.authService.reloadUserDetails(true);
      var that = this;
      this.lock.checkSession({}, function (err, authResult) {
        if (err) {
          that.WriteLog('Error', err);
        }
        if (authResult) {
          that.WriteLog('AuthResult', authResult);
        }
        var date = new Date().toString();
        var status = false;
        if (err && err.code == 'login_required') {
          status = true;
          that.logout();
        } else if (authResult) {
          localStorage.setItem('isTokenExpired', String(status));
          localStorage.setItem('tokenRefreshTime', date);
        }
        return status;
      });
    }, 1000);
  }
  //--- Auth0 --//
  clearRedeirectUrl() {
    this.authService.redirectUserTo('');
  }
  auth0APIToken() {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
      }),
    };
    var body = JSON.stringify({
      client_id: environment.auth0API.client_id,
      client_secret: environment.auth0API.client_secret,
      audience: environment.auth0API.url + 'api/v2/',
      grant_type: environment.auth0API.grant_type,
    });
    return this._http
      .post<string>(environment.auth0.url + 'oauth/token', body, httpOptions)
      .pipe(
        map((response) => {
          return response['access_token'];
        })
      );
  }
  auth0SendResetPasswordLinkApi(emailId) {
    var that = this;
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      responseType: 'text' as 'json'
    };
    var body = JSON.stringify({
      client_id: environment.auth0.clientId,
      email: emailId,
      connection: environment.auth0.connection,
    });
    return this._http
      .post<IUser>(
        environment.auth0.url + 'dbconnections/change_password',
        body,
        httpOptions
      )
      .pipe(
        map((response) => {
          return response;
        }),
        catchError(function (error) {
          console.error('Auth0 change_password error', error);
          that._loaderService.display(false);
          that._toastService.addToast({
            title: 'Error Occurred',
            msg: 'Something went wrong.',
            timeout: 5000,
            theme: 'bootstrap',
            position: 'bottom-right',
            type: 'error',
          });
          return of(null);
        })
      );
  }

  
  auth0ResetPasswordApi(emailId) {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
      }),
    };
    var body = JSON.stringify({
      client_id: environment.auth0.clientId,
      email: emailId,
      connection: environment.auth0.connection,
    });
    this._http
      .post<IUser>(
        environment.auth0.url + 'dbconnections/change_password',
        body,
        httpOptions
      )
      .subscribe((response) => {
        this._toastService.addToast({
          title: 'Error Occurred',
          msg: 'User with same email address already registered.',
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'error',
        });
      });
    const config = {
      ignoreBackdropClick: true,
      class: 'modal-position deletemodal',
      keyboard: false,
      backdrop: true,
    };
    this.modalRef = this.modalService.show(this.passwordReset, config);
  }
  auth0SearchUserByEmailId(emailId) {
    return this.auth0APIToken().pipe(
      map((response) => {
        const httpOptions = {
          headers: new HttpHeaders({
            authorization: 'Bearer ' + response,
          }),
        };
        return this._http
          .get<object[]>(
            environment.auth0.url +
            'api/v2/users-by-email?email=' +
            encodeURIComponent(emailId.toLowerCase()),
            httpOptions
          )
          .pipe(
            map((response) => {
              this.userList = response;
              return response.filter(function (item) {
                return (
                  item['identities'][0].connection ==
                  environment.auth0.connection
                );
              });
            })
          );
      })
    );
  }

  auth0CreateUser(emailId, password, isBlocked) {
    var that = this;
    return this.auth0APIToken().pipe(
      map((response) => {
        const httpOptions = {
          headers: new HttpHeaders({
            authorization: 'Bearer ' + response,
          }),
        };
        var body = {
          connection: environment.auth0.connection,
          email: emailId,
          email_verified: true,
          user_metadata: { ispasswordreset: true },
          password: password,
          blocked: isBlocked,
        };
        return this._http
          .post<IUser>(
            environment.auth0.url + 'api/v2/users',
            body,
            httpOptions
          )
          .pipe(
            map((response) => {
              return response;
            }),
            catchError(function (error) {
              that._loaderService.display(false);
              that._toastService.addToast({
                title: 'Error Occurred',
                msg: 'User with same email address already registered.',
                timeout: 5000,
                theme: 'bootstrap',
                position: 'bottom-right',
                type: 'error',
              });
              return error;
            })
          );
      })
    );
  }

  auth0UpdateUser(
    id,
    newEmailId,
    isBlocked,
    IsDeleted,
    provider: string = environment.auth0.connection
  ) {
    var that = this;
    return this.auth0APIToken().pipe(
      map((response) => {
        const httpOptions = {
          headers: new HttpHeaders({
            authorization: 'Bearer ' + response,
          }),
        };
        var body = {
          connection: provider,
          email: newEmailId,
          name: newEmailId,
          blocked: isBlocked,
        };
        if (IsDeleted) {
          this._http
            .delete<IUser>(
              environment.auth0.url + 'api/v2/users/' + encodeURIComponent(id),
              httpOptions
            )
            .pipe(map((response) => { }));
        }
        return this._http
          .patch<IUser>(
            environment.auth0.url + 'api/v2/users/' + encodeURIComponent(id),
            body,
            httpOptions
          )
          .pipe(
            map((response) => {
              return response;
            }),
            catchError(function (error) {
              that._loaderService.display(false);
              that._toastService.addToast({
                title: 'Error Occurred',
                msg: 'User with same email address already registered.',
                timeout: 5000,
                theme: 'bootstrap',
                position: 'bottom-right',
                type: 'error',
              });
              return error;
            })
          );
      })
    );
  }

  auth0UpdateUserPassword(
    id,
    Password,
    provider: string = environment.auth0.connection
  ) {
    var that = this;
    return this.auth0APIToken().pipe(
      map((response) => {
        const httpOptions = {
          headers: new HttpHeaders({
            authorization: 'Bearer ' + response,
          }),
        };
        var body = {
          connection: provider,
          password: Password,
        };

        return this._http
          .patch<IUser>(
            environment.auth0.url + 'api/v2/users/' + encodeURIComponent(id),
            body,
            httpOptions
          )
          .pipe(
            map((response) => {
              return response;
            }),
            catchError(function (error) {
              that._loaderService.display(false);
              that._toastService.addToast({
                title: 'Error Occurred',
                msg: 'Something went wrong please try again later.',
                timeout: 5000,
                theme: 'bootstrap',
                position: 'bottom-right',
                type: 'error',
              });
              return error;
            })
          );
      })
    );
  }
  deleteUser(id) {
    return this.auth0APIToken().pipe(
      map((response) => {
        const httpOptions = {
          headers: new HttpHeaders({
            authorization: 'Bearer ' + response,
          }),
        };
        return this._http
          .delete<IUser>(
            environment.auth0.url + 'api/v2/users/' + encodeURIComponent(id),
            httpOptions
          )
          .pipe(
            map((response) => {
              return response;
            })
          );
      })
    );
  }

  onLogin(loginStatus) {
    this.currentUser = this.authService.user;
    this.gerateUserResetPasswordLink(this.currentUser.UserName).subscribe(
      (res) => {
        res.subscribe((res) => { });
      }
    );
    this._propertyManagement
      .GetFlaggedPropertyCount(this.currentUser.Id)
      .subscribe((res) => {
        if (res) {
          this.unresolvedFlagCount = parseInt(res.toString());
          if (this.unresolvedFlagCount > 0) {
            const config = {
              ignoreBackdropClick: true,
              class: 'deletemodal',
              keyboard: false,
              backdrop: true,
            };
            this.modalRefunresolvedFlag = this.modalService.show(
              this.unresolvedFlagModal,
              config
            );
          }
        }
      });
  }

  CheckPendingBuyerQuestionnaire(userId: number) {
    this.userManagerService
      .CheckPendingBuyerQuestionnaire(userId)
      .subscribe((res) => {
        this.isPendingBuyerQuestions = res as boolean;
        if (this.isPendingBuyerQuestions == true) {
          const config = {
            ignoreBackdropClick: true,
            class: 'modal-position commonmodal questionnaire-login-modal',
            keyboard: false,
            backdrop: true,
          };
          this.modalBuyerQuestionnaire = this.modalService.show(
            this.pendingBuyerQuestionnaireFlagModal,
            config
          );
        }
      });
  }

  CheckIfUserAccepted1031TradeParticipationAgreement(userGuid: string) {
    this.currentUser = this.authService.user;
    this.userManagerService.getUserDetails(userGuid).subscribe((res) => {
      if (localStorage.getItem('isEBRAShown') == null) {
        if (res.IsEBRALinkSent && !res.IsEBRA_Accepted) {
          const config = {
            ignoreBackdropClick: true,
            class: 'modal-position deletemodal',
            keyboard: false,
            backdrop: true,
          };
          this.modalIsEBRA = this.modalService.show(this.EBRAModal, config);
          localStorage.setItem('isEBRAShown', JSON.stringify(true));
        }
      }
    });
  }

  WPlogout() {
    this.IsLogOut = true;
    const config = {
      ignoreBackdropClick: true,
      class: 'smallpopup',
      keyboard: false,
      backdrop: true,
    };
    this.modalRefLogout = this.modalService.show(this.logoutTemplate, config);
  }

  async WriteLog(type, response) {
    try {
      var date = new Date();
      var user = JSON.parse(localStorage.getItem('currentUser'));
      var logValue = {
        Type: type,
        User: user != null ? user : '',
        response: response,
        Date: date,
      };
      const log = { log: logValue };
      await this._commonService.WriteLog(log).subscribe((res) => { });
    } catch (ex) { }
  }

  gerateUserResetPasswordLink(userid) {
    return this.auth0APIToken().pipe(
      map((response) => {
        const httpOptions = {
          headers: new HttpHeaders({
            authorization: 'Bearer ' + response,
          }),
        };
        const body = {
          result_url: environment.auth0.callbackURL,
          user_id: userid,
        };
        return this._http
          .post<IUser>(
            environment.auth0.url + 'api/v2/tickets/password-change',
            body,
            httpOptions
          )
          .pipe(
            map((response) => {
              return response;
            })
          );
      })
    );
  }

  createUserAndGenerateResetPassword(emailId) {
    return this.auth0APIToken().pipe(
      map((response) => response),
      switchMap((response) => {
        const httpOptions = {
          headers: new HttpHeaders({
            authorization: 'Bearer ' + response,
          }),
        };
        return this._http
          .get<object[]>(
            environment.auth0.url +
            'api/v2/users-by-email?email=' +
            emailId.toLowerCase(),
            httpOptions
          )
          .pipe(
            map((response) => {
              return response;

              //this.userList = response;
              //let res = response.filter(function (item) { return item["identities"][0].connection == environment.auth0.connection })
              //if (res.length == 0) {
              //    return this.auth0CreateUser(emailId, "", false).subscribe(res => {
              //        res.subscribe(res => {
              //            if (res["user_id"]) {
              //                const body = {
              //                    "result_url": environment.auth0.callbackURL,
              //                    "user_id": res["user_id"]
              //                }
              //                return this._http.post<IUser>(environment.auth0.url + "api/v2/tickets/password-change", body, httpOptions).map(response => {
              //                    return response;
              //                });
              //            }
              //        })
              //    })
              //}
              //else {
              //    return null;
              //}
            }),
            map((res) => res),
            switchMap((response) => {
              this.userList = response;
              let res = response.filter(function (item) {
                return (
                  item['identities'][0].connection ==
                  environment.auth0.connection
                );
              });
              if (res.length == 0) {
                return this.auth0CreateUser(
                  emailId,
                  environment.auth0.defaultPassword,
                  false
                ).pipe(
                  map((res) => res),
                  switchMap((res) => {
                    return res.pipe(
                      map((res) => res),
                      switchMap((res) => {
                        if (res['user_id']) {
                          const body = {
                            result_url: environment.auth0.callbackURL,
                            user_id: res['user_id'],
                          };
                          return this._http
                            .post<IUser>(
                              environment.auth0.url +
                              'api/v2/tickets/password-change',
                              body,
                              httpOptions
                            )
                            .pipe(
                              map((response) => {
                                return response;
                              })
                            );
                        }
                      })
                    );
                  }),
                  map((res) => res)
                );
              } else {
                if (res[0]['user_id']) {
                  const body = {
                    result_url: environment.auth0.callbackURL,
                    user_id: res[0]['user_id'],
                  };
                  return this._http
                    .post<IUser>(
                      environment.auth0.url + 'api/v2/tickets/password-change',
                      body,
                      httpOptions
                    )
                    .pipe(
                      map((response) => {
                        return response;
                      })
                    );
                }
              }
            }),
            map((res) => res)
          );
      }),
      map((response) => response)
    );
  }

  ImageUPload(imgLst: IPropertyFileUpload[]) {
    this.showImageStatus = true;
    var user = JSON.parse(localStorage.getItem('UploadedImageList'));
    let newarr = [];
    if (user != null) {
      newarr = [...user, ...imgLst];
    } else {
      newarr = imgLst;
    }
    localStorage.setItem('UploadedImageList', JSON.stringify(newarr));
    this.GetUploadedImages();
    this.uploadedFiles = imgLst;
    const foo = new Observable((subscriber) => {
      imgLst.forEach((file) => {
        subscriber.next(
          this._fileUploadService.uploadFile(file).subscribe((response) => {
            if (response != null && response.length > 0) {
              localStorage.setItem(
                'UploadedImageList',
                JSON.stringify(this.imagesList)
              );
              this.uploadedFiles = JSON.parse(
                localStorage.getItem('UploadedImageList')
              );
              let result = [];

              result = response;
              let fileId =
                result[0].UploadedFileId != null &&
                  result[0].UploadedFileId > 0 &&
                  result[0].UploadedFileId != undefined
                  ? result[0].UploadedFileId
                  : 0;
              if (fileId > 0) {
                this.uploadedFiles.filter(
                  (x) => x.ImageGuid == result[0].ImageGuid
                )[0].ImageStatus = 'Success';
                localStorage.setItem(
                  'UploadedImageList',
                  JSON.stringify(this.uploadedFiles)
                );
                this.GetUploadedImages();
                this.RefreshComponent();
              } else {
                localStorage.setItem(
                  'UploadedImageList',
                  JSON.stringify(this.imagesList)
                );
                this.uploadedFiles = JSON.parse(
                  localStorage.getItem('UploadedImageList')
                );
                this.uploadedFiles.filter(
                  (x) => x.ImageGuid == file.ImageGuid
                )[0].ImageStatus = 'Failed';
                localStorage.setItem(
                  'UploadedImageList',
                  JSON.stringify(this.uploadedFiles)
                );
                let filename = this.uploadedFiles.filter(
                  (x) => x.ImageGuid == file.ImageGuid
                )[0].documentName;
                this.GetUploadedImages();
                var _message =
                  filename != null && filename != '' && filename != undefined
                    ? filename + ' has been failed to upload, please retry'
                    : 'File upload has been failed to upload, please retry';
                this._toastService.addToast({
                  title: 'Failed',
                  msg: _message,
                  timeout: 5000,
                  theme: 'bootstrap',
                  position: 'bottom-right',
                  type: 'error',
                });
              }
            } else {
              localStorage.setItem(
                'UploadedImageList',
                JSON.stringify(this.imagesList)
              );
              this.uploadedFiles = JSON.parse(
                localStorage.getItem('UploadedImageList')
              );
              this.uploadedFiles.filter(
                (x) => x.ImageGuid == file.ImageGuid
              )[0].ImageStatus = 'Failed';
              let newFiles = this.uploadedFiles;
              localStorage.setItem(
                'UploadedImageList',
                JSON.stringify(newFiles)
              );
              let filename = this.uploadedFiles.filter(
                (x) => x.ImageGuid == file.ImageGuid
              )[0].documentName;
              this.GetUploadedImages();
              var _message =
                filename != null && filename != '' && filename != undefined
                  ? filename + ' has been failed to upload, please retry'
                  : 'File upload has been failed to upload, please retry';
              this._toastService.addToast({
                title: 'Failed',
                msg: _message,
                timeout: 5000,
                theme: 'bootstrap',
                position: 'bottom-right',
                type: 'error',
              });
            }
          })
        );
      });
    });

    foo.subscribe((x) => {
      console.log(1);
    });
  }

  private RefreshComponent() {
    let imageData = JSON.parse(localStorage.getItem('UploadedImageList'));
    if (imageData != null && imageData != undefined) {
      let ongoingList = imageData.filter(
        (f) => f.ImageStatus == '' || f.ImageStatus == null
      );
      let refreshTab = localStorage.getItem('currentFileRefreshTab');
      if (
        (ongoingList == null || ongoingList == 0) &&
        refreshTab != undefined &&
        refreshTab != null
      ) {
        let fileData: any = [];
        fileData = imageData.find(
          (i) => i.sourceUrl == this.router.url && i.RefreshTab == refreshTab
        );
        if (fileData != undefined && fileData != null) {
          let compInput = {
            sourceUrl: fileData.sourceUrl,
            refreshTab: fileData.RefreshTab,
          };
          this.callComponentMethod(compInput);
        }
      }
    }
  }

  FileUpload(imgLst: IPropertyFileUpload[]) {
    this.showImageStatus = true;
    var user = JSON.parse(localStorage.getItem('UploadedImageList'));
    let newarr = [];
    if (user != null) {
      newarr = [...user, ...imgLst];
    } else {
      newarr = imgLst;
    }
    localStorage.setItem('UploadedImageList', JSON.stringify(newarr));
    this.GetUploadedImages();
    this.uploadedFiles = imgLst;
    const foo1 = new Observable((subscriber) => {
      imgLst.forEach((file) => {
        let inputFileUpload = {} as IFileUpload;
        inputFileUpload.documentName = file.documentName;
        inputFileUpload.fileCategoryId = file.fileCategoryId;
        inputFileUpload.id = 0;
        inputFileUpload.objectId = file.objectId;
        inputFileUpload.objectTypeId = file.objectTypeId;
        inputFileUpload.type = 'Documents';
        inputFileUpload.OfferGuid = file.OfferGuid;
        inputFileUpload.ImageGuid = file.ImageGuid;
        inputFileUpload.userId = file.userId;
        inputFileUpload.PrincipalPropertyType =
          file.PrincipalPropertyType != null ? file.PrincipalPropertyType : '';
        inputFileUpload.PrincipalGuid =
          file.PrincipalGuid != null ? file.PrincipalGuid : '0000';
        subscriber.next(
          this._fileUploadService
            .uploadFiles(inputFileUpload, file.fileToUpload)
            .subscribe((response) => {
              if (response != null && response.length > 0) {
                localStorage.setItem(
                  'UploadedImageList',
                  JSON.stringify(this.imagesList)
                );
                this.uploadedFiles = JSON.parse(
                  localStorage.getItem('UploadedImageList')
                );
                let result = [];

                result = response;
                let fileId =
                  result[0].UploadedFileId != null &&
                    result[0].UploadedFileId > 0 &&
                    result[0].UploadedFileId != undefined
                    ? result[0].UploadedFileId
                    : 0;
                if (fileId > 0) {
                  this.uploadedFiles.filter(
                    (x) => x.ImageGuid == result[0].ImageGuid
                  )[0].ImageStatus = 'Success';
                  localStorage.setItem(
                    'UploadedImageList',
                    JSON.stringify(this.uploadedFiles)
                  );
                  this.GetUploadedImages();
                  this.RefreshComponent();
                } else {
                  localStorage.setItem(
                    'UploadedImageList',
                    JSON.stringify(this.imagesList)
                  );
                  this.uploadedFiles = JSON.parse(
                    localStorage.getItem('UploadedImageList')
                  );
                  this.uploadedFiles.filter(
                    (x) => x.ImageGuid == file.ImageGuid
                  )[0].ImageStatus = 'Failed';
                  localStorage.setItem(
                    'UploadedImageList',
                    JSON.stringify(this.uploadedFiles)
                  );
                  let filename = this.uploadedFiles.filter(
                    (x) => x.ImageGuid == file.ImageGuid
                  )[0].documentName;
                  this.GetUploadedImages();
                  var _message =
                    filename != null && filename != '' && filename != undefined
                      ? filename + ' has been failed to upload, please retry'
                      : 'File upload has been failed to upload, please retry';
                  this._toastService.addToast({
                    title: 'Failed',
                    msg: _message,
                    timeout: 5000,
                    theme: 'bootstrap',
                    position: 'bottom-right',
                    type: 'error',
                  });
                }
              } else {
                localStorage.setItem(
                  'UploadedImageList',
                  JSON.stringify(this.imagesList)
                );
                this.uploadedFiles = JSON.parse(
                  localStorage.getItem('UploadedImageList')
                );
                this.uploadedFiles.filter(
                  (x) => x.ImageGuid == file.ImageGuid
                )[0].ImageStatus = 'Failed';
                let newFiles = this.uploadedFiles;
                localStorage.setItem(
                  'UploadedImageList',
                  JSON.stringify(newFiles)
                );
                let filename = this.uploadedFiles.filter(
                  (x) => x.ImageGuid == file.ImageGuid
                )[0].documentName;
                this.GetUploadedImages();
                var _message =
                  filename != null && filename != '' && filename != undefined
                    ? filename + ' has been failed to upload, please retry'
                    : 'File upload has been failed to upload, please retry';
                this._toastService.addToast({
                  title: 'Failed',
                  msg: _message,
                  timeout: 5000,
                  theme: 'bootstrap',
                  position: 'bottom-right',
                  type: 'error',
                });
              }
            })
        );
      });
    });

    foo1.subscribe((x) => {
      console.log(1);
    });
  }

  GetUploadedImages(): Observable<IPropertyFileUpload[]> {
    if (
      localStorage.getItem('UploadedImageList') != null &&
      localStorage.getItem('UploadedImageList') != undefined
    ) {
      this.imagesList = JSON.parse(localStorage.getItem('UploadedImageList'));
      let imageData = JSON.parse(localStorage.getItem('UploadedImageList'));
      if (this.imagesList != null) {
        let FailedList = imageData.filter((f) => f.ImageStatus == 'Failed');
        let completedList = imageData.filter((f) => f.ImageStatus == 'Success');
        let ongoingList = imageData.filter(
          (f) => f.ImageStatus == '' || f.ImageStatus == null
        );
        this.OngoingImageCount =
          ongoingList != null && ongoingList != undefined
            ? ongoingList.length
            : 0;
        this.CompletedImageCount =
          completedList != null && completedList != undefined
            ? completedList.length
            : 0;
        this.FailedImageCount =
          FailedList != null && FailedList != undefined ? FailedList.length : 0;
        this.totalImageCount =
          imageData != null && imageData != undefined ? imageData.length : 0;
        return this.imagesList;
      } else {
        localStorage.setItem('mydata', JSON.stringify(this.uploadedFiles));
        this.imagesList = JSON.parse(localStorage.getItem('mydata'));
        return this.imagesList;
      }
    } else {
      localStorage.setItem('mydata', JSON.stringify(this.uploadedFiles));
      this.imagesList = JSON.parse(localStorage.getItem('mydata'));
      return this.imagesList;
    }
  }

  async GetMarketSnapShotTypeData() {
    let propertyValues =
      await this.Analytics.GetMarketchartTypeDataForPreviousMonths().toPromise();
    localStorage.setItem('PropertyTypesValues', JSON.stringify(propertyValues));
  }

  loadRoleBasedPermissions(roleId: number) {
    this.permissionService.getAllowedPermissions(roleId).subscribe(response => {
      this.permissionService.setPermissions(response);
    });
  }
}
